// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import 'element-ui/lib/theme-chalk/index.css';
import componentsJunhai from 'components-junhai';
import 'components-junhai/lib/style/index.css';
import 'normalize.css';
import '@/assets/iconfont/iconfont.css';
import '@/permission'; // permission control
import App from './App';
import router from './router';
import './main.less';
import store from './store/store';
import VueSocketIO from 'vue-socket.io';


Vue.use(componentsJunhai);

Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV !== 'production',
  connection: `${process.env.API_URL}sendMsg`,
  options: {
    // 创建时是否自动连接 我们这里设定为false,在指定页面再开启
    autoConnect: false,
    // 路径(默认值：/socket.io/)
    transports: ['polling'],
    // 附加请求头（在服务器端的 socket.handshake.headers 对象中找到）
    extraHeaders: {},
  },
}),
);


Vue.config.productionTip = false;
Vue.use(Vuex);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js